import headShark from '../assets/new-ui/head-shark.png'
// import pointShark from '../assets/point-shark.png'
// import pointSharkPass from '../assets/point-shark-pass.png'
import pointShark from '../assets/new-ui/myNFT/future-point.png'
import pointSharkPass from '../assets/new-ui/myNFT/passed-point.png'
// import { useState } from 'react'
import { isMobile } from '../utils/utils'

export default function ProgressNumNFT(props) {
  const {numNFT} = props
  // const [boxDetail1,setBoxDetail1] = useState(false)
  // const [boxDetail2,setBoxDetail2] = useState(false)
  // const [boxDetail3,setBoxDetail3] = useState(false)
  // const [boxDetail4,setBoxDetail4] = useState(false)
  // const [boxDetail5,setBoxDetail5] = useState(false)

  function calLeftHeadShark() {
    if (isMobile()) {
      if (numNFT < 21) return 30 + (numNFT - 5) * 13
      else return 225 + (numNFT - 20) * 8
    }
    else {
      // if (numNFT < 21) return 23 + numNFT * 29
      // else return 603 + (numNFT - 20) * 14
      if (numNFT === 0) return 4
      else if (numNFT > 0 && numNFT < 20) return 5 + 3.6*numNFT - 3
      else if (numNFT >= 20) return 76 + 1.8 * (numNFT - 20) - 1.4
    }
    
  }

  return (
    <div className='progressBarContainer'>
      <div className='progressBar'>
        <div className='emptyBar'></div>
        {/* {
          isMobile()
            ? <div className='ownerBar' style={numNFT < 31 ? {height: `${calLeftHeadShark() + 25}px`} : {height: '662px'}}></div>
            : <div className='ownerBar' style={numNFT < 31 ? {width: `${calLeftHeadShark() + 25}px`} : {width: '822px'}}></div>
        } */}
        
        <div className='ownerPoint point0'>
          <img src={numNFT < 1 ? pointShark : pointSharkPass} alt='' />
          <div className='ownerPointNumber'>0</div>
        </div>

        <div className={numNFT < 5 ? 'ownerPoint point5' : 'ownerPoint point5 passed'}>
          <img src={numNFT < 5 ? pointShark : pointSharkPass} alt='' />
          <div className='ownerPointNumber'>5 NFTs</div>
          <div className='ownerPointConnect'>-</div>
          <div className='ownerPointPercent'>1%</div>
          <div className='detailPercent'>Gain 1% revenue from selling NFT when this period finish</div>
        </div>

        <div className={numNFT < 10 ? 'ownerPoint point10' : 'ownerPoint point10 passed'}>
          <img src={numNFT < 10 ? pointShark : pointSharkPass} alt='' />
          <div className='ownerPointNumber'>10 NFTs</div>
          <div className='ownerPointConnect'>-</div>
          <div className='ownerPointPercent'>2%</div>
          <div className='detailPercent'>Gain 2% revenue from selling NFT when this period finish</div>
        </div>

        <div className={numNFT < 15 ? 'ownerPoint point15' : 'ownerPoint point15 passed'}>
          <img src={numNFT < 15 ? pointShark : pointSharkPass} alt='' />
          <div className='ownerPointNumber'>15 NFTs</div>
          <div className='ownerPointConnect'>-</div>
          <div className='ownerPointPercent'>3%</div>
          <div className='detailPercent'>Gain 3% revenue from selling NFT when this period finish</div>
        </div>

        <div className={numNFT < 20 ? 'ownerPoint point20' : 'ownerPoint point20 passed'}>
          <img src={numNFT < 20 ? pointShark : pointSharkPass} alt='' />
          <div className='ownerPointNumber'>20 NFTs</div>
          <div className='ownerPointConnect'>-</div>
          <div className='ownerPointPercent'>4%</div>
          <div className='detailPercent'>Gain 4% revenue from selling NFT when this period finish</div>
        </div>
        <div className={numNFT < 30 ? 'ownerPoint point30' : 'ownerPoint point30 passed'}>
          <img src={numNFT < 30 ? pointShark : pointSharkPass} alt='' />
          <div className='ownerPointNumber'>30 NFTs</div>
          <div className='ownerPointConnect'>-</div>
          <div className='ownerPointPercent'>5%</div>
          <div className='detailPercent'>Gain 5% revenue from selling NFT when this period finish</div>
        </div>

        {
          isMobile()
            ? (<div className={numNFT > 4 ? 'ownerLogo' : 'ownerLogoHidden'} style={numNFT < 31 ? {top: `${calLeftHeadShark()}px`}: {top: '305px'}}>
                <img src={headShark} alt='' />
              </div>)
            : (<div className='ownerLogo' style={numNFT < 31 ? {left: `${calLeftHeadShark() - 2}%`} : {right: '4%'}}>
                <img src={headShark} alt='' />
              </div>)
        }
        
      </div>
    </div>
  )
}